module.exports = __webpack_public_path__ + "static/media/icon_check_border.b386c3a3.svg";